var _excluded = ["isOpen", "onOpenChange", "trigger", "label", "items", "size", "variant", "icon", "isDisabled", "data-testid", "shouldCloseMenuOnItemClick", "triggerAriaLabel"],
    _excluded2 = ["dataTestId", "label", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from '../../utils';
import { Menu } from '../Menu';
import { ActionItem } from './ActionItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var ActionsDropdownMenu = forwardRef((_ref, ref) => {
  var {
    isOpen,
    onOpenChange,
    trigger,
    label,
    items,
    size = 'medium',
    variant = 'default',
    icon,
    isDisabled,
    'data-testid': triggerTestId,
    shouldCloseMenuOnItemClick = true,
    triggerAriaLabel
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var internalTrigger = size === 'small' ? /*#__PURE__*/_jsx(Menu.ThreeDotsTrigger, _objectSpread({
    "data-component": "ActionsDropdownMenu",
    "aria-label": triggerAriaLabel !== null && triggerAriaLabel !== void 0 ? triggerAriaLabel : label,
    "data-testid": triggerTestId !== null && triggerTestId !== void 0 ? triggerTestId : 'actions-dropdown-menu',
    variant: variant
  }, props)) : /*#__PURE__*/_jsx(Menu.ActionTrigger, _objectSpread({
    "data-component": "ActionsDropdownMenu",
    size: size,
    label: label,
    "aria-label": triggerAriaLabel,
    variant: variant,
    icon: icon,
    "data-testid": triggerTestId !== null && triggerTestId !== void 0 ? triggerTestId : 'actions-dropdown-menu'
  }, props));
  return /*#__PURE__*/_jsx(Menu, _objectSpread(_objectSpread({
    dropdownTestId: "actions-dropdown-menu-list"
  }, props), {}, {
    isOpen: isOpen,
    onOpenChange: onOpenChange,
    size: size === 'large' ? 'large' : 'small',
    trigger: trigger !== null && trigger !== void 0 ? trigger : internalTrigger,
    isDisabled: isDisabled,
    ref: ref,
    children: items.map((_ref2, index) => {
      var {
        dataTestId,
        label,
        onClick: _onClick
      } = _ref2,
          itemProps = _objectWithoutProperties(_ref2, _excluded2);

      return /*#__PURE__*/_createElement(ActionItem, _objectSpread(_objectSpread({
        "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : "actions-dropdown-menu-item-".concat(index),
        onClick: () => {
          // Closing the dropdown, will move the focus to the trigger
          shouldCloseMenuOnItemClick && onOpenChange(false); // Using timeout, will first move the focus to the trigger and only then, fire the callback.
          // This is for cases when `ActionItem` click event opens a modal for example.
          // When closing the modal, we want the focus to move to the trigger.

          setTimeout(() => {
            _onClick === null || _onClick === void 0 ? void 0 : _onClick();
          });
        }
      }, itemProps), {}, {
        label: label,
        key: "".concat(label, "-").concat(index)
      }));
    })
  }));
});
ActionsDropdownMenu.displayName = 'ActionsDropdownMenu';
//# sourceMappingURL=ActionsDropdownMenu.js.map